import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log(`FIX FOUC:  ${Date.now()}`)
    this.element.classList.add('loaded')
  }
}
